import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { VehicleTypeService } from '../vehicle-type.service'

@Component({
  selector: 'app-vehicle-type-table',
  templateUrl: './vehicle-type-table.component.html',
  styleUrls: ['./vehicle-type-table.component.scss']
})
export class VehicleTypeTableComponent implements OnInit {
  displayedColumns: string[] = ['id', 'name'];
  dataSource: any;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  constructor(private global: GlobalService, private http: HttpService, public vehicleTypeService : VehicleTypeService) { 
    this.getVehicleTypes();
    this.global.set_master_page_title = 'Vehicle Type';
    this.vehicleTypeService.downloadVehicleType.subscribe((is_new_vehicle_present) => {
      console.log(is_new_vehicle_present);
      if (is_new_vehicle_present) {
        this.getVehicleTypes();
      }
    });
  }

  registerVehicleType() {
    console.log('click for register relation type')
    this.showVehicleTypeRegister();
    this.vehicleTypeService.vehicleTypeUpdate.emit(null);
    this.vehicleTypeService.set_vehicle_type_data = null;
  }

  getVehicleTypes() {
    this.http.getVehicletype().subscribe((data: VehicleType[]) => {
      console.log(data);
      this.dataSource = new MatTableDataSource<VehicleType>(data);
      this.dataSource.sort = this.sort;
    }, (error) => {
      console.log(error);
    });
  }

  editVehicleType(relation_type) {
    this.showVehicleTypeRegister();
    this.vehicleTypeService.vehicleTypeUpdate.emit(relation_type);
    this.vehicleTypeService.set_vehicle_type_data = relation_type;
  }

  showVehicleTypeRegister() {
    this.vehicleTypeService.is_display_vehicle_type_register_component = true;
  }

  hideVehicleTypeRegister() {
    this.vehicleTypeService.is_display_vehicle_type_register_component = false;
  }

  ngOnInit() {
  }

}

export interface VehicleType {
  id: number;
  name: string;
}
